"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowInput = exports.buildWorkflow = exports.WorkflowDec = exports.Workflow = void 0;
const client_1 = require("@prisma/client");
const function_1 = require("fp-ts/lib/function");
const D = __importStar(require("io-ts/lib/Decoder"));
const codecs_1 = require("../../codecs");
const WorkflowTransition_dto_1 = require("../../WorkflowTransition.dto");
const creative_work_tagging_machine_1 = require("../creative-work-tagging/creative-work-tagging.machine");
const Workflow_CreativeWorkConfig_1 = require("./Workflow_CreativeWorkConfig");
class Workflow {
}
exports.Workflow = Workflow;
exports.WorkflowDec = (0, function_1.pipe)(D.struct({
    workflowId: D.number,
    workflowType: codecs_1.WorkflowTypeDec,
    version: D.number,
    resourceId: D.string,
    resourceTitle: D.string,
    cwmClassType: D.string,
    cwmClassTypeLabel: D.string,
    radarId: D.number,
    workflowConfig: D.UnknownRecord,
    assignee: D.nullable(D.string),
    state: D.string,
    priority: codecs_1.PriorityDec,
    deadlineAt: D.nullable(codecs_1.DateFromISOString),
    source: D.nullable(D.string),
    comment: D.nullable(D.string),
    completed: D.boolean,
    completedAt: D.nullable(codecs_1.DateFromISOString),
    createdBy: D.string,
    createdAt: codecs_1.DateFromISOString,
    updatedAt: codecs_1.DateFromISOString,
    executionArn: D.nullable(D.string),
}), D.intersect(D.partial({
    transitions: D.array(WorkflowTransition_dto_1.WorkflowTransitionDec),
})), D.withMessage(() => 'Workflow'));
const buildWorkflow = (data = {}) => {
    return {
        workflowId: Math.floor(Math.random() * 10000),
        priority: client_1.WorkflowPriority.MEDIUM,
        comment: null,
        ...(0, exports.buildWorkflowInput)(data),
        deadlineAt: null,
        source: null,
        createdAt: new Date(),
        updatedAt: new Date(),
    };
};
exports.buildWorkflow = buildWorkflow;
let resourceIdCount = 0;
const buildWorkflowInput = (data = {}) => {
    var _a;
    const workflowConfig = (0, Workflow_CreativeWorkConfig_1.buildWorkflowCreativeWorkConfig)(data.workflowConfig);
    return {
        workflowType: client_1.WorkflowType.CREATIVE_WORK_TAGGING,
        version: 1,
        resourceId: `MOCK_RESOURCE_ID_${++resourceIdCount}`,
        resourceTitle: 'MOCK RESOURCE TITLE',
        cwmClassType: 'http://data.disney.com/creativeWork#FeatureFilm',
        cwmClassTypeLabel: 'Feature Film',
        radarId: 1234,
        workflowConfig: workflowConfig,
        state: creative_work_tagging_machine_1.CREATIVE_WORK_TAGGING_AVAILABLE,
        createdBy: 'TANEI001',
        deadlineAt: null,
        assignee: null,
        source: null,
        ...data,
        completedAt: ((_a = data.completedAt) !== null && _a !== void 0 ? _a : data.completed) ? new Date() : null,
    };
};
exports.buildWorkflowInput = buildWorkflowInput;
//# sourceMappingURL=Workflow.dto.js.map